
export function FileMaxSizeValidator(maxSize: number, customMessage=null) {
  return (control: any): { [key: string]: any } | null => {
    if (control.file) {
      if(control.file.size>maxSize){
        return { invalidFileSize: customMessage || `El archivo no puede superar los ${Math.round(maxSize/ (1024 * 1024))}MB` };
      }
    }
    return null;
  };
}
